module.exports = __webpack_public_path__ + "img/skills-berserker-barb-2.568d6cc9.png";